// packages/chordpro/src/link.js
//
// ВЫВОД связи «заголовок документа ↔ секции аранжировки» по ИМЕНАМ.
//
// ⚠️ Это НЕ действующая модель, а её запасной случай. Связь ХРАНИТСЯ —
// `song.chart.links`, см. шапку section-map.js: вывод по имени не находил ни
// одного блока в русском чарте (`Куплет 1` и `Verse 1` — разные строки).
// Отсюда этот модуль зовётся ровно тогда, когда связей нет вовсе: шейр,
// опубликованный до волны D, и чарт, которого ещё не касались.
//
// Две ступени: точное совпадение ключа, иначе — по семье. [CHORUS] находит и
// Chorus-1, и Chorus-2: один текст припева, играется дважды.

import { normalizeSectionName } from './section-name.js';

/**
 * @param {string} headingName имя раздела из текста
 * @param {string[]} sectionNames имена секций аранжировки
 * @returns {string[]} имена секций, с которыми заголовок связан
 */
export function linkTargets(headingName, sectionNames) {
  const sections = Array.isArray(sectionNames) ? sectionNames : [];
  const h = normalizeSectionName(headingName);
  if (!h.key) return [];

  const exact = sections.filter((n) => normalizeSectionName(n).key === h.key);
  if (exact.length) return exact;

  // Без семьи вторая ступень невозможна: иначе «Bananas» слипся бы с
  // «Bananas 2» только потому, что оба незнакомые.
  if (!h.family) return [];
  return sections.filter((n) => normalizeSectionName(n).family === h.family);
}
